export const widgetPreviewViews = {
  widget: 'widget',
  popup: 'popup',
  full: 'full',
  checkout: 'checkout',
}

export const popupBackgroundColor = '#FFFFFF'

export const declineActionStyles = {
  button: 'button',
  link: 'link',
}
